import { curveBumpX, curveLinear, line } from "d3";
import { linePadding } from "./constants";
import generateLineData from "./generateLineData";
import { DrawParams } from "./types";

export default function drawEQLine({
  svg,
  xScale,
  yScale,
  type,
  freq,
  freqRange,
  q,
}: DrawParams) {
  const selector = "eqLine";
  const lineData = generateLineData({ centerFreq: freq, freqRange, q, type });

  svg
    .selectAll(`path.${selector}`)
    .data([1])
    .join("path")
    .attr("class", `${selector}`)
    .attr("fill", "none")
    .attr("stroke", "white")
    .attr("stroke-width", 4)
    .attr("transform", `translate(0, ${linePadding.top})`)
    .attr(
      "d",
      line<{ x: number; y: number }>()
        .x((d) => xScale(d.x))
        .y((d) => yScale(d.y))
        .curve(
          type === "hipass" || type === "lopass" ? curveLinear : curveBumpX
        )(lineData)
    );
}
